import { Container, Grid } from '@material-ui/core'
import React from 'react'
import { ButtonHLPure, InputHLPure } from '../../pures'
import { t } from 'i18next'
import { useTranslation } from 'react-i18next'

const UserAdministrationUserData = (props) => {
    const { t, selectedUser, handleBack } = props
    const { t: tCommon } = useTranslation('common')

    return (
        <Container maxWidth={"md"}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                        <InputHLPure
                            labelInput={tCommon("name")}
                            typeInput={"text"}
                            valueInput={selectedUser.firstName || "-"}
                            handleChangeInput={() => { }}
                            inputActive={false}
                            disabled
                        />
                        <InputHLPure
                            labelInput={tCommon("firstLastName")}
                            typeInput={"text"}
                            valueInput={selectedUser.firstLastName || "-"}
                            handleChangeInput={() => { }}
                            inputActive={false}
                        />
                        <InputHLPure
                            labelInput={tCommon("secondLastName")}
                            typeInput={"text"}
                            valueInput={selectedUser.secondLastName || "-"}
                            handleChangeInput={() => { }}
                            inputActive={false}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                        <InputHLPure
                            labelInput={t("status")}
                            typeInput={"text"}
                            valueInput={selectedUser.active ? 'Activo' : 'Inactivo'}
                            handleChangeInput={() => { }}
                            inputActive={false}
                        />
                        <InputHLPure
                            labelInput={tCommon("mail")}
                            typeInput={"text"}
                            valueInput={selectedUser.email}
                            handleChangeInput={() => { }}
                            inputActive={false}
                        />
                        <InputHLPure
                            labelInput={tCommon("phone")}
                            typeInput={"text"}
                            valueInput={selectedUser.phoneNumber || "-"}
                            handleChangeInput={() => { }}
                            inputActive={false}
                        />
                    </Grid>
                </Grid>
                <Grid xs={12} className="button-actions" style={{ paddingBlock: '16px' }}>
                    <ButtonHLPure primary outlined onClick={handleBack} nameBtn={tCommon("back")} />
                </Grid>
            </Grid>
        </Container>
    )
}

export default UserAdministrationUserData